import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, of, Subject, switchMap, tap } from 'rxjs';
import { FilterOperators } from 'src/app/common/enums';
import { DictionaryService } from 'src/app/data/dictionary.service';
import { UserService } from 'src/app/data/user.service';
import { FilterType } from 'src/app/list-filter/enums/filter-type.enum';
import { FilterService } from 'src/app/list-filter/services/filter.service';
import { DictionaryItem } from 'src/app/models/dictionary-item';
import { FilterTypeEnum } from 'src/app/models/enums/filter-type-enum';

@Injectable()
export class OrdersListFilterService extends FilterService {
  protected userService: UserService;
  private translateService = inject(TranslateService);
  private dictionaryService = inject(DictionaryService);

  protected filterType = FilterTypeEnum.OrdersList;
  private subject: Subject<string> = new Subject<string>();
  private mpks$ = new BehaviorSubject<DictionaryItem[]>(null);


  constructor() {
    const userService = inject(UserService);

    super(FilterTypeEnum.OrdersList, userService);
    this.userService = userService;


    this.config = [
      {
        id: 1,
        name: 'orderItemStatusId',
        label: this.translateService.instant('Order.List.OrderItemStatus'),
        property: 'OrderItemStatusId',
        operator: FilterOperators.Equal,
        default: true,
        multiple: true,
        type: FilterType.Select,
        datasource$: this.dictionaryService.getOrderItemStatuses(),
        searchTextChangeCallback: (value: any) => this.subject.next(value),
      },
    ];
  }
}
